import React,{useState,useRef,useEffect,useContext} from "react";
import Card from "../elements/Card/Card";
import Swal from 'sweetalert2';
import Button from "../elements/Button/Button";
import Person from "../../assets/Images/person.jpg"
import CryptoJS from 'crypto-js';
import { AuthContext } from "../../context/AuthContext";
import ClipLoader from "react-spinners/ClipLoader";
import Notification from "../Notification/Notification";
import { useNavigate } from "react-router-dom";
// import Applicant from "./Applicants";
import { useLocation } from "react-router-dom";
import MessageModal from "./MessageModal";
import ModalBox from "../elements/ModalBox/ModalBox";
import Textinput from "../elements/TextInput/TextInput";
import InboxGenie from "./InboxGenieCount";
const RecommendedMatches = () =>{
  const location = useLocation();
    const dropdownRef = useRef(null);
    const dropdownRefOne = useRef(null);
    const dropdownRefTwo = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isResumeOpen, setIsResumeOpen] = useState(null);
    const [isResumeOption,setResumeOption]=useState(null);
    const[clicked,setClicked]=useState(false);
    const { token } = useContext(AuthContext);
    const [ResumeDetails,setResumeDetails] = useState([]);
    const [fitment,setFitment]=useState([]);
    const navigate = useNavigate();
    let score
    const[resumeID,setResumeID]=useState('');
    const[pipelineValue,setPipelineValue]=useState('');
    const jobDesc_id=location.state?.jd_id;
    const jobTitle = location.state?.job_title;
    const job_id = location.state?.jobId;
    const [jobIdValue,setJobId]=useState(job_id);
    const [candidates,setCandidates]=useState('');
    const [candidatesContacted,setCandidatesContacted]=useState('');
    const [candidatesShortlisted,setCandidatesShortlisted]=useState('');
    const [candidatesCommented,setCandidatesCommented]=useState('');
    const [ companyId, setCompanyID ] = useState("");
    const [upcommingInterviews,setInterviewsCount]=useState('');
    const [Locations, setLocations] = useState([]);
    const [Companies, setCompanies] = useState([]);
    const [assessments, setAssessments] = useState([]);
    const [Keywords, setKeywords] = useState([]);
    const [From, setFrom] = useState([]);
    const [fromWithCount, setFromWithCount] = useState({
      "All": 0,
      "Resume Box": 0,
      "Naukri": 0
    });
    const encryptedMetadataAll = localStorage.getItem('metadata');

    const [filterOpen, setfilter]=useState(false);
    const handleAllFilters = () =>{
      console.log("filter open")
      setfilter(true)
    }
    const handleCloseFilter =()=>{
      setfilter(false)
    }




    var decryptedMetadataAll;
      if (encryptedMetadataAll){
          decryptedMetadataAll = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadataAll, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
      }
    const [processingMessage, setProcessingMessage] = useState('No resume data available.');
        const toggleDropdownPipeline = () => {
          setIsOpen((prev) => !prev);
        };

        const toggleDropdownResumePipeline = (index) => {
          console.log("incomming......");
          setIsResumeOpen((prev) => prev===index?null:index);
          // console.log(ResumeDetails['891fcc57bccb4fc3a21a2bc84a2f346b']['candidate']['name'])
        };
        const toggleDropdownResumeOption = (index) => {
          setResumeOption((prev) => prev===index?null:index);
          // console.log(ResumeDetails['891fcc57bccb4fc3a21a2bc84a2f346b']['candidate']['name'])
        };
    const [isOpenMessage, setIsOpenMessage] = useState(false);
      
        const toggleDropdownMessage = () => {
          setIsOpenMessage((prev) => !prev);
        };
    // const [applicants,setApplicantStatus]=useState(1);
    // const handleApplicant = () =>{
    //     setApplicantStatus(2);
    // }
    const handleClickOutside = (event) => {
        if ((isResumeOpen || isResumeOption) &&
        !(
          dropdownRefOne.current?.contains(event.target) ||
          dropdownRefTwo.current?.contains(event.target)
        )) {
            // setIsOpen(false);
            // setIsOpenMessage(false)
            setResumeOption(false)
            setIsResumeOpen(null)
        }
        
    };
    const [notification, setNotification] = useState({ message: "", type: "" });
    // const [naukriCount, setNaukriCount] = useState([{"analysed":10,"parsed":4,"queue":10,"total":24}]);
    const [naukriCount, setNaukriCount] = useState([]);
    const [isInboxOpen, setIsInboxOpen] = useState(false);
    const [lastUpdated, setLastUpdated] = useState("");
    useEffect(()=>{
      // set current time span as local time for setLastUpdated
      const currentTime = new Date().toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true});
        setLastUpdated(currentTime);
    },[])
    
      const showNotification = (message, type) => {   //For Notification
        setNotification({ message, type });
        setTimeout(() => {
          setNotification({ message: "", type: "" });
        }, 3000); // Auto-hide after 3 seconds
      };
    
    const getResponse = async() =>{
        var jd_id = jobDesc_id;
        const encryptedMetadata = localStorage.getItem('metadata');
        // if (encryptedMetadata){
        //     const decryptedMetadata = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadata, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
        //     if(decryptedMetadata.jd_id){
        //         jd_id = decryptedMetadata.jd_id;
        //     }
        // }
        // setJDvalue(jd_id);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({jd_id:jd_id,fromJob:true,job_id:job_id}), process.env.REACT_APP_SECRETKEY).toString();
        var searchData = { data:encryptedData}
        console.log(searchData,"searchData");
        setIsLoading(true);
        try {
            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/JD/getJdDetail`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  token: token
                },
                body: JSON.stringify(searchData), 
            });
            const result = await response.json();
            console.log("Server Response:", result);
            if (!response.ok) {
                throw new Error(result.error);
            }
            const decryptedData = JSON.parse(CryptoJS.AES.decrypt(result.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
            if(decryptedData['message']){
                console.log("message:",decryptedData['message'])
                setProcessingMessage(decryptedData['message'])
                return;
            }

            Object.keys(decryptedData).forEach((resName) => {
              let resume_details = decryptedData[resName]?.["resumedetail"];
              let fitmentDetails = decryptedData[resName]?.["fitment"]?.["resumes"];
              // console.log("decrypted Data : ",resName);
              Object.keys(resume_details || {}).forEach((key) => {
                // console.log("resume_details Data : ",resume_details);
                // console.log("key : ",key);
                  const resumes = resume_details[key];
          
                  if (resumes && typeof resumes === "object") {
                    console.log("resume value : ",resumes);
                      // Object.values(resumes).forEach((resume) => {
                        // console.log("resume each data : ",resume);
                          if (resumes?.candidate?.address) {
                            console.log("resume candidate address value : ",resumes?.candidate?.address);
                              const address = resumes.candidate.address.includes(",")
                                  ? resumes.candidate.address.split(",")[0]?.trim()
                                  : resumes.candidate.address.trim();
          
                              if (address) {
                                  setLocations((prev) => [...new Set([...prev, address])]);
                              }
                          }
                          if (resumes?.companies_worked_at) {
                              const companies_worked_at = resumes?.companies_worked_at.includes(",")
                                  ? resumes?.companies_worked_at.split(",")[0]?.trim()
                                  : resumes?.companies_worked_at.trim();
          
                              if (companies_worked_at) {
                                setCompanies((prev) => [...new Set([...prev, companies_worked_at])]);
                              }
                          }
                          if (resumes?.candidate?.languages) {
                              const language = resumes?.candidate?.languages.includes(",")
                                  ? resumes?.candidate?.languages.split(",")[0]?.trim()
                                  : resumes?.candidate?.languages.trim();
          
                              if (language) {
                                setAssessments((prev) => [...new Set([...prev, language])]);
                              }
                          }
                          if (resumes?.profile) {
                              const profile = resumes?.profile.includes(",")
                                  ? resumes?.profile.split(",")[0]?.trim()
                                  : resumes?.profile.trim();
          
                              if (profile) {
                                setKeywords((prev) => [...new Set([...prev, profile])]);
                              }
                          }
                          if (resumes?.resume_source) {
                            // let req_type = resumes.resume_source && resumes.resume_source.includes(",")
                            // ? resumes.resume_source.split(",")[0]?.trim()
                            // : resumes.resume_source;
                            // let req_type = fitmentDetails.map((fitment) => fitment?.resume_id === resumes?.doc_id ? fitment?.resume_source : null);
                            let req_type = fitmentDetails.find((fitment) => fitment?.resume_id === resumes?.doc_id)?.resume_source || null;
                            console.log("req_type: ",req_type);
                            console.log("fitmentDetails: ",fitmentDetails);
                            console.log("resumes: ",resumes);
                        
                            // Correct conditional assignment
                            req_type = req_type === "user"
                                ? "Resume Box"
                                : req_type === "nakuri" || req_type === "naukri"
                                ? "Naukri"
                                : req_type;
                        
                            if (req_type) {
                                setFrom((prev) => [...new Set([...prev, req_type])]);
                                // setFromWithCount((prev) => ({
                                //     ...prev,
                                //     [req_type]: (prev[req_type] || 0) + 1,
                                // }));
                                setFromWithCount((prev) => {
                                  const updateCount = (prev[req_type] ||0) + 1;
                                  const totalCount = Object.keys(prev)
                                  .filter((key) => key !== "All")
                                  .reduce((acc, key) => acc + prev[key], 0) + 1;
                                  return {
                                    ...prev,
                                    [req_type]: updateCount,
                                    "All": totalCount,
                                };
                                })
                            }
                        }
                        
                      // });
                  }
              });
          });
            console.log("resumeDetails: ",decryptedData)
            console.log("resumeDetails: ",decryptedData[jd_id]["resumedetail"])
            console.log("fitment_Details: ",decryptedData[jd_id]["fitment"]["resumes"])

            let resumeDet;
            let ctr=0;
            let contactCount=0;
            let shortlistCount=0;
	    let commentCount = 0;
            const recommendedStatus = decryptedData;
            console.log("resumestatus: ",recommendedStatus);
            Object.keys(recommendedStatus).forEach((resName)=>{
              console.log("resName: ",recommendedStatus[resName]["resumedetail"]);
              resumeDet=recommendedStatus[resName]["resumedetail"]
              Object.keys(resumeDet).map((key) => {
                ctr++;
                if (resumeDet[key]["pipeline_type"] === "contact") {
                  contactCount++;
                }
                if (resumeDet[key]["pipeline_type"] === "shortlist") {
                  shortlistCount++;
                }
		if (
  		resumeDet[key] &&
  		resumeDet[key]['comment_count'] > 0
		) {
                  commentCount++;
                }
                console.log("res pipe status: ", ctr);
              });
            })
            console.log("resumeDetails: ",recommendedStatus)
            let count=0;
            // Object.keys(decryptedData).map((key,val)=>(
            //   count++,
            //   console.log(count,"Rec")
            // ))
            
            if(ctr<1000){
              setCandidates(ctr);
            }
            if(ctr>=1000){
              setCandidates(ctr/1000+"k")
            }
            if(contactCount<1000){
              setCandidatesContacted(contactCount);
            }
            if(contactCount>=1000){
              setCandidatesContacted(contactCount/1000+"k")
            }
            if(shortlistCount<1000){
              setCandidatesShortlisted(shortlistCount);
            }
            if(shortlistCount>=1000){
              setCandidatesShortlisted(shortlistCount/1000+"k")
            }
            if(commentCount<1000){
              setCandidatesCommented(commentCount);
            }
            if(commentCount>=1000){
              setCandidatesCommented(commentCount/1000+"k")
            }


            // setAiSearchResult(decryptedData[jd_id]);
            setResumeDetails(decryptedData[jd_id]['resumedetail'])
            if(decryptedData[jd_id] && decryptedData[jd_id]["naukri_resume_status"]){
              setNaukriCount(decryptedData[jd_id]["naukri_resume_status"]);
            }

            if(decryptedData[jd_id] && decryptedData[jd_id]["fitment"] && decryptedData[jd_id]["fitment"]["resumes"]){
              setFitment(decryptedData[jd_id]["fitment"]["resumes"]);
            }

            // console.log(decryptedData)
            // showNotification(result.message, "success");
        } catch (error) {
            console.error("Error uploading file:", error);
            // showNotification(error.message, "error");
        }finally {
            setIsLoading(false); // Always hide loader after the request
        }
      }
      const handleGenieStatus = async () => {
        var jd_id = jobDesc_id;
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({jd_id:jd_id,fromJob:true,job_id:job_id}), process.env.REACT_APP_SECRETKEY).toString();
        var searchData = { data:encryptedData}
        setIsLoading(true);
        try {
            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/JD/getResumeStatus`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  token: token
                },
                body: JSON.stringify(searchData), 
            });
            const result = await response.json();
            console.log("Server Response:", result);
            if (!response.ok) {
                throw new Error(result.error);
            }
            const decryptedData = JSON.parse(CryptoJS.AES.decrypt(result.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
            if(decryptedData['message']){
                console.log("message:",decryptedData['message'])
                setProcessingMessage(decryptedData['message'])
                return;
            }
            setNaukriCount(decryptedData.naukri_resume_status);
            const currentTime = new Date().toLocaleString('en-IN', {
              timeZone: 'Asia/Kolkata',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: true});
            setLastUpdated(currentTime);
            setIsInboxOpen(true);
          } catch(err) {
            console.log(err,"Error while refreshing Inbox Genie")
          }finally {
            setIsLoading(false);
        }
      }

        const [filteredResumes, setFilteredResumes] = useState([])
        useEffect(()=>{
        setFilteredResumes(ResumeDetails);
        cardsFilter('all');
          console.log(filteredResumes)
        },[ResumeDetails]);


        const [fromFilterChecked, setFromFilterChecked] = useState([]);
        const handleJobLocationChange = (e) =>{
          let name = e.target.name === "Resume Box" 
                      ? "user" 
                      : e.target.name === "Naukri" 
                      ? "nakuri" 
                      : e.target.name;
          console.log(e.target.checked, name);
          if (e.target.checked) {
            setFromFilterChecked((prev) => ({
              ...prev,
              [name]: true
            }));
          } else {
            setFromFilterChecked((prev) => {
              const prevData = { ...prev };
              delete prevData[name];
              return prevData;
            });
          }
        
          setTimeout(() => setfilter(false), 0);
        }
        const handleSingleJobLocationChange = (e) => {
            let name =
                e.target.name === "Resume Box"
                    ? "user"
                    : e.target.name === "Naukri"
                    ? "nakuri"
                    : e.target.name;
        
            console.log(e.target.checked, name);
        
            setFromFilterChecked(e.target.checked ? { [name]: true } : {});
        };
        useEffect(() => {
          const filterKey = Object.keys(fromFilterChecked)[0];
          const filterValue = fromFilterChecked[filterKey];
      
          if (typeof ResumeDetails === "object" && ResumeDetails !== null) {
              if (filterValue) {
                  if (filterKey === "All") {
                      setFilteredResumes(ResumeDetails);
                  } else {
                      const filtered = Object.fromEntries(
                          Object.entries(ResumeDetails).filter(([key, resume]) => {
                              let req_type = fitment.find((fitment) => fitment?.resume_id === resume?.doc_id)?.resume_source || null;
                              if (filterKey === "nakuri") {
                                return req_type === "naukri" || req_type === "nakuri";
                            }
                              return req_type === filterKey;
                          })
                      );
                      setFilteredResumes(filtered);
                  }
              } else {
                  setFilteredResumes(ResumeDetails);
              }
          } else if (Array.isArray(ResumeDetails)) {
              if (filterValue) {
                  if (filterKey === "All") {
                      setFilteredResumes(ResumeDetails);
                  } else {
                      const filtered = ResumeDetails.filter((resume) => {
                          let req_type = fitment.find((fitment) => fitment?.resume_id === resume?.doc_id)?.resume_source || null;
                          if (filterKey === "nakuri") {
                              return req_type === "naukri" || req_type === "nakuri";
                          }
      
                          return req_type === filterKey;
                      });
                      setFilteredResumes(filtered);
                  }
              } else {
                  setFilteredResumes(ResumeDetails);
              }
          } else {
              console.warn("ResumeDetails is not a valid object or array:", ResumeDetails);
              setFilteredResumes({});
          }
      }, [fromFilterChecked, ResumeDetails, fitment]);       

      //   useEffect(() => {
      //     const filterKey = Object.keys(fromFilterChecked)[0];
      //     const filterValue = fromFilterChecked[filterKey];
      
      //     if (Array.isArray(ResumeDetails)) {
      //       if (filterValue) {
      //         if (filterKey === "All") {
      //             setFilteredResumes(ResumeDetails); // Show all resumes if "All" is selected
      //         } else {
      //             const filtered = ResumeDetails.filter(
      //                 (resume) => resume.resume_source === filterKey
      //             );
      //             setFilteredResumes(filtered);
      //         }
      //     } else {
      //         setFilteredResumes(ResumeDetails);
      //     }
      //     } else {
      //         console.warn("ResumeDetails is not an array:", ResumeDetails);
      //         setFilteredResumes(ResumeDetails);
      //     }
      // }, [fromFilterChecked, ResumeDetails]);      

      const isResumeDetailsEmpty = !ResumeDetails || Object.keys(ResumeDetails).length < 1;
      var totalResumeCount = 0;
      if(!isResumeDetailsEmpty){
          totalResumeCount = Object.keys(ResumeDetails).length
      }

    const getUpcommingInterviews = async() =>{
      console.log("inside interview get");
      const cardContent = { job_id: job_id, type: "upcoming" };
              const encryptedDashData = CryptoJS.AES.encrypt(
                  JSON.stringify(cardContent),
                  process.env.REACT_APP_SECRETKEY
              ).toString();
      
      try{
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/calendly/fetchScheduleDetails`, {
          method: "POST",
          headers: { "Content-Type": "application/json", token },
          body: JSON.stringify({ data: encryptedDashData }),
      });

            const rawData = await response.text();
            const responsedata = JSON.parse(rawData);
            const decryptedData = responsedata.data;
            setInterviewsCount(decryptedData.length)
            console.log(responsedata, "upcomming interview");
      }
      catch(error) {
        console.error("Error uploading file:", error);
        // showNotification(error.message, "error");
    }
    }

    useEffect(()=>{
      const encryptedMetadata = localStorage.getItem('metadata');
      const decryptedMetadata = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadata, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
      setCompanyID(decryptedMetadata.cid);
      getResponse();
      getUpcommingInterviews();
    },[])
    
    useEffect(() => {
      
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        
    }, [isResumeOption,isResumeOpen]);
    const ModalBody=(
      <div>
       <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 "  CardClass="min-w-md mx-auto bg-white shadow rounded-lg overflow-hidden w-11/12 p-2 mt-7 !rounded-xl !hidden"
          body={<>
          <Textinput placeholder="Search for a Project" labelclass="hidden" className="!w-full border-2 pl-10 pr-4 py-2.5 !border border-gray-150 rounded-md focus:outline-none focus:ring-2 text-black mt-1 focus:ring-cyan-200"/>
          </>}
        />
        <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 "  CardClass="min-w-md mx-auto bg-white shadow rounded-lg overflow-hidden w-11/12 p-2 mt-7 !rounded-xl"
          body={<>
          <p className="mb-0 font-medium">From</p>
                      {
                          From.slice(0,3).map((degree) => (
                              <Textinput
                              type="checkbox"
                              labelclass="hidden"
                              className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                              divclass="flex h-6 mt-2"
                              postlabel={degree}
                              postlabelclass="ml-2"
                              name={degree}
                              checked={fromFilterChecked[degree === "Resume Box" ? "user": degree === "Naukri" ? "nakuri" : degree] || false} 
                              onChange={(e)=> handleJobLocationChange(e)}
                              key={degree}
                              />
                          ))
                      }
                      
          </>}
        />
        <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 "  CardClass="min-w-md mx-auto bg-white shadow rounded-lg overflow-hidden w-11/12 p-2 mt-7 !rounded-xl"
          body={<>
          <p className="mb-0 font-medium">Location</p>
                      {
                          Locations.slice(0,3).map((location,index) => (
                              <Textinput
                              type="checkbox"
                              labelclass="hidden"
                              className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                              divclass="flex h-6 mt-2"
                              postlabel={location}
                              postlabelclass="ml-2"
                              key={location}
                              />
                          ))
                      }
                      
                      {/* {seeLocations &&
                      Locations.slice(3).map((location,index) => (
                          <Textinput
                          type="checkbox"
                          labelclass="hidden"
                          className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                          divclass="flex h-6 mt-2"
                          postlabel={location}
                          postlabelclass="ml-2"
                          key={location}
                          
                          />
                      ))}
  
                      <p className="text-sm hover:cursor-pointer mt-2 text-[#059669]" onClick={()=>showMoreLocations((prev)=>!prev)}>show more...</p> */}
          </>
          }
        />
        <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 "  CardClass="min-w-md mx-auto bg-white shadow rounded-lg overflow-hidden w-11/12 p-2 mt-7 !rounded-xl"
          body={<>
          <p className="mb-0 font-medium">Skills and assessments</p>
                      {
                          assessments.slice(0,4).map((assessments) => (
                              <Textinput
                              type="checkbox"
                              labelclass="hidden"
                              className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                              divclass="flex h-[auto] mt-2"
                              postlabel={assessments}
                              postlabelclass="ml-2"
                              key={assessments}
                              />
                          ))
                      }
                      
                      {/* {seeAssessments &&
                      assessments.slice(4).map((assessments,index) => (
                          <Textinput
                          type="checkbox"
                          labelclass="hidden"
                          className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                          divclass="flex h-6 mt-2"
                          postlabel={assessments}
                          postlabelclass="ml-2"
                          key={assessments}
                          />
                      ))}
  
                      <p className="text-sm hover:cursor-pointer mt-2 text-[#059669]" onClick={()=>showMoreAssessments((prev)=>!prev)}>Show More...</p> */}
          </>}
        />
        <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 "  CardClass="min-w-md mx-auto bg-white shadow rounded-lg overflow-hidden w-11/12 p-2 mt-7 !rounded-xl"
          body={<>
          <p className="mb-0 font-medium">Companies</p>
                      {
                          Companies.slice(0,2).map((company) => (
                              <Textinput
                              type="checkbox"
                              labelclass="hidden"
                              className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                              divclass="flex h-[auto] mt-2"
                              postlabel={company}
                              postlabelclass="ml-2"
                              key={company}
                              />
                          ))
                      }
                      
                      {/* {seeCompanies &&
                      Companies.slice(2).map((company,index) => (
                          <Textinput
                          type="checkbox"
                          labelclass="hidden"
                          className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                          divclass="flex h-6 mt-2"
                          postlabel={company}
                          postlabelclass="ml-2"
                          key={company}
                          />
                      ))}
  
                      <p className="text-sm hover:cursor-pointer mt-2 text-[#059669]" onClick={()=>showMoreCompanies((prev)=>!prev)}>show more...</p> */}
          </>}
        />
        <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 "  CardClass="min-w-md mx-auto bg-white shadow rounded-lg overflow-hidden w-11/12 p-2 mt-7 !rounded-xl"
          body={<>
          <p className="mb-0 font-medium">Keywords</p>
                      {
                          Keywords.slice(0,2).map((keyword) => (
                              <Textinput
                              type="checkbox"
                              labelclass="hidden"
                              className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                              divclass="flex h-6 mt-2"
                              postlabel={keyword}
                              postlabelclass="ml-2"
                              key={keyword}
                              />
                          ))
                      }
                      
                      {/* {seeKeywords &&
                      Keywords.slice(2).map((keyword,index) => (
                          <Textinput
                          type="checkbox"
                          labelclass="hidden"
                          className="text-lg !w-1/12 w-5 h-5 mb-0 mt-1"
                          divclass="flex h-6 mt-2"
                          postlabel={keyword}
                          postlabelclass="ml-2"
                          key={keyword}
                          />
                      ))}
  
                      <p className="text-sm hover:cursor-pointer mt-2 text-[#059669]" onClick={()=>showMoreKeywords((prev)=>!prev)}>show more...</p> */}
          </>}
        />
      </div>);

    const ModalHeader=(
      <p className="text-black font-medium mb-0">All Filters</p>
      
    );


    // const handlePipeline = (value,index) =>{
    //   setClicked(true);
    //   console.log("clicked",index.doc_id)
    //   // console.log("resumeid: ",resumeID);
    //   let res_id=index.doc_id;
    //   console.log(res_id,"ressss");
    //   setResumeID(res_id);
    //   setPipelineValue(value);
    // }

    const handlePipelineStatus = async(value,index,name,email,jobtitle,score,skipschedule) =>{
      let cid;
      let plan_id;
      if(decryptedMetadataAll && decryptedMetadataAll.cid){
        cid = parseInt(decryptedMetadataAll.cid);
      }	
       if(decryptedMetadataAll && decryptedMetadataAll.plan_id){
        plan_id = parseInt(decryptedMetadataAll.plan_id);
      }

      const JdData = {
            resume_id: index.doc_id,
            candidate_id: "",
            job_id:jobIdValue,
            type:value,
            job_title:jobtitle,
            name:name,
            candidate_mail:email||null,
            score:score,
            skipschedule:skipschedule||false,
            cid:cid,
	      plan_id:plan_id
            
          };
          console.log("jddata:",JdData)
      
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(JdData),
            process.env.REACT_APP_SECRETKEY
          ).toString();
          const encryptjson = { data: encryptedData };
          
          let userConfirmed;
            if (value === "contact") {
            userConfirmed = await Swal.fire({
              icon: "warning",
              title: "Are you sure to add to the pipeline?",
              text: "Once added, an email will be sent.",
              confirmButtonText: "OK",
              showCancelButton: true,
            });
            } else {
            userConfirmed = await Swal.fire({
              icon: "warning",
              title: "Are you sure to add to the pipeline?",
              confirmButtonText: "OK",
              showCancelButton: true,
            });
            }

        
          if (!userConfirmed.isConfirmed) {
            console.log("User canceled pipeline addition.");
            return;
          }
          
          setIsLoading(true);
            try {
              const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/job/addPipeline`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    token: token,
                  },
                  body: JSON.stringify(encryptjson),
                }
              );
          
              const data = await response.json();
          if (data.status === "error") {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: data.error
                });
                return;
              }
              const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8)
              );
                if (value === "contact" && decryptedData.notschedule && !skipschedule) {
                  const userConfirmed_schedule = await Swal.fire({
                  icon: "warning",
                  title: "Are you sure to schedule?",
                  confirmButtonText: "Schedule",
                  cancelButtonText: "Skip",
                  showCancelButton: true,
                  });

                  if (userConfirmed_schedule.isDismissed) {
                  handlePipelineStatus(value, index, name, email, jobtitle, score, true);
                  return;
                  }

                  if (userConfirmed_schedule.isConfirmed) {
                    handleReschedule_pipeline(jobIdValue);
                  return;
                  }
                }
              if (decryptedData.notpasscode) {
                const userConfirmed = await Swal.fire({
                  icon: "warning",
                  title: "Passcode Required",
                  text: "You need to set a passcode to proceed.",
                  confirmButtonText: "Set Passcode",
                  showCancelButton: true,
                });

                if (userConfirmed.isConfirmed) {
                    navigate("/Usersettings", { state: { setting: true } });
                  return;
                }
                if (userConfirmed.isDismissed) {
                  return;
                  }
              }
              showNotification(
                `Candidate added to pipeline as ${value}` ,
                "success"
              );
              console.log(decryptedData, "decrypt");
              getResponse();
              setClicked(false);
            } catch (error) {
              console.error("Error occurred:", error);
            } finally {
              setIsLoading(false);
            }
          
          
    }
    const [MessageResumeId, setMessageResumeId] = useState("");
    const [CID, setCID] = useState("");
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [ResumeMessageavailable, setResumeMessageAvailable] = useState(false);
    const [messageContent, setMessageContent] = useState([]);
    const [messageID, setMessageId] = useState([]);
    const [messageCreated, setMessageCreated] = useState([]);
    const setResumeMessage = async (doc_id,cid) => {
      try {
        const MessageData = {
          candidate_id: doc_id,
          cid: cid,
          job_id:jobIdValue
        };
        console.log("Message Data : ",MessageData)
    
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(MessageData),
          process.env.REACT_APP_SECRETKEY
        ).toString();
        const encryptMessageData = { data: encryptedData };
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/job/getResumeComments`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
            body: JSON.stringify(encryptMessageData),
          }
        );
        const data = await response.json();
        const commentData = JSON.parse(
          CryptoJS.AES.decrypt(
            data.data,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
        if(commentData.length > 0){
          setMessageResumeId(doc_id);
          setCID(cid);
          // setMessageContent(commentData.map((key) => key.comment));
          // setMessageCreated(commentData.map((key) => key.created_at));
          setMessageContent(commentData.map((item) => ({
              comment: item.comment,
              created_at: item.created_at
          })));        
          setMessageId(commentData.map((key) => key.comment_id));
          setResumeMessageAvailable(true);
          setShowMessageModal(true);
        } else {
          setMessageResumeId(doc_id);
          setCID(cid);
          setShowMessageModal(true);
        }
        console.log("Resume Comment Data : ",commentData);
      } catch (err) {
        console.log(err);
      }
    }
    const ResumeMessage = async (message, ResumeID,cid, update=false) => {
      try {
        let MessageData = {};
        let url = "";
        if(update){
           MessageData = {
            comment: message,
            comment_id: messageID
          };
          url="updateResumeComments";
        }else{
           MessageData = {
            comment: message,
            candidate_id: ResumeID,
            cid: cid,
	    job_id:jobIdValue
          };
          url="addResumeComments";
        }
        console.log("Message Data : ",MessageData)
    
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(MessageData),
          process.env.REACT_APP_SECRETKEY
        ).toString();
        const encryptMessageData = { data: encryptedData };
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/job/${url}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
            body: JSON.stringify(encryptMessageData),
          }
        );
        const data = await response.json();
        if (data.message === "Comment added successfully") {
          Swal.fire({
            title: "Success!",
            text: "Your comment has been added to the resume.",
            icon: "success",
            confirmButtonText: "OK"
          });
        }else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong. Please try again.",
              icon: "error",
              confirmButtonText: "OK"
            });
        }
      } catch(err) {
        console.log(err);
      }
      getResponse();
      setMessageResumeId("");
      setCID("");
      setMessageContent([]);
      setMessageId("");
      setResumeMessageAvailable(false);
      setShowMessageModal(false);
    }
    const handleMessageSave = (message) => {
      ResumeMessage(message,MessageResumeId,CID);
    }

    // const handleHiddenCandidate = async(value) =>{
    //   const HiddenData = {
    //       job_pipeline_id: jobPipelineId,
    //       status: value            
    //       };
    //       console.log("jddata:",JdData)
      
    //       const encryptedData = CryptoJS.AES.encrypt(
    //         JSON.stringify(JdData),
    //         process.env.REACT_APP_SECRETKEY
    //       ).toString();
    //       const encryptjson = { data: encryptedData };
          
    //       const userConfirmed = await Swal.fire({
    //         icon: "warning",
    //         title: "Are you sure to add to the pipeline?",
    //         text: "Once added, an email will be sent.",
    //         confirmButtonText: "OK",
    //         showCancelButton: true,
    //       });
        
    //       if (!userConfirmed.isConfirmed) {
    //         console.log("User canceled pipeline addition.");
    //         return;
    //       }
          
          
    //         try {
    //           const response = await fetch(
    //             `${process.env.REACT_APP_SERVER_URL}/job/updatePipelineProfileStatus`,
    //             {
    //               method: "POST",
    //               headers: {
    //                 "Content-Type": "application/json",
    //                 token: token,
    //               },
    //               body: JSON.stringify(encryptjson),
    //             }
    //           );
          
    //           const data = await response.json();
          
    //           const decryptedData = JSON.parse(
    //             CryptoJS.AES.decrypt(data.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8)
    //           );
    //           showNotification(
    //             `Candidate added to pipeline as ${value}` ,
    //             "success"
    //           );
    //           console.log(decryptedData, "decrypt");
    //           getResponse();
    //           setClicked(false);
    //         } catch (error) {
    //           console.error("Error occurred:", error);
    //         }
          
          
    // }

    const handleReschedule_pipeline = async (job_id) => {
      try {
        const jobData = await fetchJobDetails_Pipeline(job_id);
        console.log(jobData);
        localStorage.setItem("jobCreationData", JSON.stringify(jobData));
        navigate("/NewJobPost", { state: { reschedule: true } });
      } catch (err) {
        console.log(err);
      }
    }
    const fetchJobDetails_Pipeline = async (job_id) => {
      const JLData = { job_id: job_id };
    
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(JLData),
        process.env.REACT_APP_SECRETKEY
      ).toString();
      const encryptjson = { data: encryptedData };
    
      try {
        const serverURL = process.env.REACT_APP_SERVER_URL;
        const response = await fetch(`${serverURL}/job/fetchJobDetails`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify(encryptjson),
        });
    
        if (!response.ok) {
          const errorMessage = responsedata?.message || "Something Went Wrong";
          throw new Error(errorMessage);
        }
    
        const responsedata = await response.json();
        const jobData = JSON.parse(
          CryptoJS.AES.decrypt(
            responsedata.data,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
    
        const jobDetails = jobData.job_details[0];
        const jobCollaborators = jobData.job_collab;
        const jobTeam = jobData.job_team;
        const jobInterviewer = jobData.job_interviewer;
        const questions = jobData.job_screen_question;
        const jobSlot = jobData.job_weeklyslot;
        const job_dateoverride = jobData.job_dateoverride;
    
        return {
          jobid: "",
          job_id: "",
          job_id_old: jobDetails.job_id,
          company_id: companyId,
          jobTitle: jobDetails.title || "",
          company: FindCompany_pipeline() || jobDetails.company,
          workplaceType: jobDetails.workplace_type,
          jobLocation: jobDetails.location,
          jobType: jobDetails.job_type,
          description: jobDetails.job_desc || "",
          selectedSkills: jobDetails.skills,
          collaborators: jobCollaborators.map((collaborator) => collaborator.uid),
          team: jobTeam.map((team) => ({
            name: team.name,
            designation: team.designation,
            url: team.url,
          })) || [{ name: "", designation: "", url: "" }],
          questions: questions,
          slots: jobSlot.reduce((acc, value) => {
            const day = WeekDay[value.day_of_week === 7 ? 0 : value.day_of_week];
            const abbreviatedDay = abbreviations[day];
            const formatTime = (time) => time.slice(0, 5);
              const formattedStartTime = formatTime(value.start_time);
              const formattedEndTime = formatTime(value.end_time);
              acc[abbreviatedDay] = `${formattedStartTime} - ${formattedEndTime}`;
              return acc;
            }, {}),
          schedule_config_days: "",
          override: job_dateoverride.reduce((acc,value)=> {
            const date = toIST(value.date);
            const formatTime = (time) => time.slice(0, 5);
            const formattedStartTime = formatTime(value.start_time);
            const formattedEndTime = formatTime(value.end_time);
            acc[date] = `${formattedStartTime} - ${formattedEndTime}`;
            return acc;
          },{}),
          interviewers: jobInterviewer.map((interviewer) => interviewer.interviewer_id),
          interview_location: jobDetails.interview_location,
          interview_duration: jobDetails.interview_duration,
          timezone: jobDetails.timezone,
        };
      } catch (error) {
        console.error("Error fetching job details:", error);
        throw error;
      }
    };
    const FindCompany_pipeline = () => {
        const encryptedMetadata = localStorage.getItem("metadata");
        const decryptedMetadata = JSON.parse(
          CryptoJS.AES.decrypt(
            encryptedMetadata,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
    
        if (
          decryptedMetadata &&
          decryptedMetadata.company_name &&
          decryptedMetadata.company_name != ""
        ) {
          var companyName = decryptedMetadata.company_name;
          return companyName;
        } else {
          return "";
        }
      };
    const [activeFilter, setActiveFilter] = useState('all');

    const cardsFilter = (filterby) => {
      setActiveFilter(filterby);
      let filtered = Object.values(ResumeDetails);
      if (filterby === 'all') {
      filtered = Object.values(ResumeDetails);
      }
      if (filterby === 'contact') {
      filtered = filtered.filter(resume => resume.pipeline_type === 'contact');
      } else if (filterby === 'shortlist') {
      filtered = filtered.filter(resume => resume.pipeline_type === 'shortlist');
      } else if (filterby === 'comment') {
      filtered = filtered.filter(resume => resume.comment_count > 0);
      }
      setFilteredResumes(filtered);
    }
    return(
        <>
        <div className="bg-white ml-12 gap-2 w-[70%] p-4 bg-opacity-[50%] rounded-xl">
          {filterOpen &&(
          <ModalBox modal_Header_Text="mb-0" Modal_Body={ModalBody} Modal_Header={ModalHeader} modal_Close_Class=" border-2 pl-2 pr-2 pt-1 pb-1 rounded-lg" Modal_Close_Func={handleCloseFilter} cardClass="min-w-md  bg-white shadow rounded-lg overflow-hidden h-full !rouded-none !w-96 opacity-none overflow-y-auto" ModalTopClass="!items-right !justify-end "/>
        )}
        <MessageModal                 
          show={showMessageModal}
          onClose={() => setShowMessageModal(false)} 
          isMessage={ResumeMessageavailable}
          messageContent={messageContent}
          // onUpdate={handleMessageUpdate}
          onSave={handleMessageSave} />
          <InboxGenie 
            show={isInboxOpen}
            onClose={()=> setIsInboxOpen(false)}
            last_updated={lastUpdated}
            naukri_content={naukriCount}
            />
        <Notification
            message={notification.message}
            type={notification.type}
            onClose={() => setNotification({ message: "", type: "" })}
        />
        {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="flex flex-col items-center">
                        <ClipLoader color="#3498db" loading={isLoading} size={50} />
                        <span className="text-white mt-4">Loading...</span>
                    </div>
                </div>
            )}
            <div>
                <div>
                <div className="flex space-between w-full justify-between gap-2">
                        <div onClick={() => cardsFilter('all')} className={`w-[177px] h-[100px] ${activeFilter === 'all' ? 'bg-[#C0E5E5]' : 'bg-[#F2F9F9]'} hover:bg-[#D9EFEF] cursor-pointer rounded-[17px] pt-[20px] pb-[20px] pl-[16px] pr-[16px] grid gap-[4px]`}>
                            <p className="mb-0 text-[27px] font-[700] mx-auto items-center text-[#059669]">{candidates||0}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto">Total Resumes</p>
                        </div>
                        <div className="w-[177px] h-[100px] bg-[#F2F9F9] hover:bg-[#D9EFEF] rounded-[17px] pt-[20px] pb-[20px] pl-[16px] pr-[16px] grid gap-[4px]">
                            <p className="mb-0 text-[27px] font-[700] mx-auto items-center text-[#059669]">{upcommingInterviews||0}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto">Upcoming Interviews</p>
                        </div>
                        <div onClick={() => cardsFilter('contact')} className={`w-[177px] h-[100px] ${activeFilter === 'contact' ? 'bg-[#C0E5E5]' : 'bg-[#F2F9F9]'} hover:bg-[#D9EFEF] cursor-pointer rounded-[17px] pt-[14px] pb-[14px] pl-[16px] pr-[16px] grid gap-[4px]`}>
                            <p className="mb-0 text-[27px] font-[700] mx-auto items-center text-[#059669]">{candidatesContacted||0}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto text-center">Candidates Contacted</p>
                        </div>
                        <div onClick={() => cardsFilter('shortlist')} className={`w-[177px] h-[100px] ${activeFilter === 'shortlist' ? 'bg-[#C0E5E5]' : 'bg-[#F2F9F9]'} hover:bg-[#D9EFEF] cursor-pointer rounded-[17px] pt-[20px] pb-[20px] pl-[16px] pr-[16px] grid gap-[4px]`}>
                            <p className="mb-0 text-[27px] font-[700] mx-auto items-center text-[#059669]">{candidatesShortlisted||0}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto">Candidates Shortlisted</p>
                        </div>
	    		              <div onClick={() => cardsFilter('comment')} className={`w-[177px] h-[100px] ${activeFilter === 'comment' ? 'bg-[#C0E5E5]' : 'bg-[#F2F9F9]'} hover:bg-[#D9EFEF] cursor-pointer rounded-[17px] pt-[20px] pb-[20px] pl-[16px] pr-[16px] grid gap-[4px]`}>
                            <p className="mb-0 text-[27px] font-[700] mx-auto items-center text-[#059669]">{candidatesCommented||0}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto">Candidates Commented</p>
                        </div>

                        {/* <div className="w-[177px] h-[100px] bg-[#F2F9F9] rounded-[17px] relative pt-[14px] pb-[14px] pl-[10px] pr-[10px] grid gap-[4px]">
                            <p className="mb-0 text-[26px] font-[700] mx-auto items-center text-[#059669]">{`1`}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto text-center "></p>
                        </div> */}
                    </div> 
                </div>
            </div>
            <div className="flex w-full mt-4" style={{justifyContent:'space-between'}}>
                        <p className="mb-0 text-xl font-[700]">Recommended Matches <span className="text-xs font-[400] text-[#747474]">{candidates||0} results</span>
                        {naukriCount.length > 0 && (
                            <div className="flex items-center ml-2">
                                <span 
                                    onClick={() => setIsInboxOpen(true)} 
                                    style={{ textDecoration: 'underline', cursor: 'pointer' }} 
                                    className="text-xs font-[400] text-[#059669]">
                                    Inbox Genie Status
                                </span>
                                <button 
                                  onClick={handleGenieStatus} 
                                  className="ml-2 p-1 rounded hover:bg-gray-200 transition"
                                  title="Refresh">
                                  <svg 
                                      xmlns="http://www.w3.org/2000/svg" 
                                      viewBox="0 0 24 24" 
                                      fill="#059669" 
                                      width="16px" 
                                      height="16px">
                                      <path d="M12 6V2L8 6l4 4V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z"/>
                                  </svg>
                              </button>
                            </div>
                        )}
                        </p>
                        <p className="mb-0 mt-2 ml-20 text-green-700 font-medium hover:cursor-pointer" onClick={handleAllFilters}>All Filters</p>
                    </div>
            <div className="flex flex-wrap gap-4">
                {/* <p className="text-[#059669] text-sm font-[500] mt-2">Filter From :</p> */}
                <div className="flex gap-4">
                {Object.entries(fromWithCount)
                .slice(0, 3)
                .map(([degree, count]) => {
                    const isChecked =
                        fromFilterChecked[
                            degree === "Resume Box"
                                ? "user"
                                : degree === "Naukri"
                                ? "nakuri"
                                : degree
                        ] || false;

                    return (
                        <div key={degree} className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                className="hidden"
                                name={degree}
                                checked={isChecked}
                                onChange={(e) => handleSingleJobLocationChange(e)}
                            />
                            <label
                                onClick={() =>
                                  handleSingleJobLocationChange({
                                        target: {
                                            name: degree,
                                            checked: !isChecked,
                                        },
                                    })
                                }
                                className={`cursor-pointer px-2 rounded-full mb-0 mt-1 text-nowrap transition-all duration-300 ${
                                    isChecked ? "bg-green-500 text-white" : "bg-yellow-500 text-black"
                                }`}
                            >
                                {degree} ({count})
                            </label>
                        </div>
                    );
                })}
                </div>
            </div>
            <div>
            <Card CardFooterClass="px-6 py-2 bg-gray-100 flex justify-end gap-2 " CardClass="min-w-md mx-auto bg-white shadow rounded-lg no-max-width  overflow-hidden mt-4 mb-4 !rounded-xl shadow border-white w-full !hidden"
                body={<>
                <div className="flex">
                    <img src={Person} className="w-28 h-28 rounded-full object-cover"></img>
                    <div className="pl-2 absolute ml-6 inset-6 mt-14 h-9 bg-green-50 shadow-lg shadow-green-700  w-20 pb-1  rounded-md ">
                    <div className="relative size-6 mt-1">
                    <svg className="size-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">

                        <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-gray-200 dark:text-neutral-700" strokeWidth="4"></circle>

                        <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-teal-400 dark:text-blue-500" strokeWidth="4" stroke-dasharray="100" stroke-dashoffset="6" stroke-linecap="round"></circle>
                    </svg>
    
                    </div>
      
         
                    <div className="absolute rounded-lg inset-2 ml-8 mt-2 mr-2 flex items-center  justify-center  text-gray-700 dark:text-white">
                        
                        <div className="h-14">
                          <p className="mb-0 text-black font-medium mt-1 ml-3">{94}%</p>
                          
                        </div>
                    </div>
                    <p className="text-xs mb-0 absolute inset-y-4 ml-8">Match</p>
                    
                    </div>

                    <div className="ml-6 hover:cursor-pointer">
                        <p className="text-xl font-medium text-black mt-3 mb-0">Sharad Bhat</p>
                        <p className="text-sm mb-0">UI/UX Designer</p>
                        <p className="text-xs mt-1">Bengaluru,Karnataka</p>
                    </div>
                   <div className="ml-auto mt-4"> 
                    <div className="relative items-center flex text-left">
      
        <Button
          type="button"
          className="text-nowrap inline-flex border-[1px] border-[#059669]  justify-center gap-x-1.5 rounded-md bg-white px-3  text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          id="menu-button"
          aria-expanded={isOpen}
          aria-haspopup="true"
          onClick={toggleDropdownPipeline}
        >
          <p className="mt-2 mb-0 text-[#059669]">Save to Pipeline</p>
          <svg
            className="-mr-2 size-6 ml-4 h-10 text-gray-400 border-l-[1px] border-[#059669]"
            viewBox="0 0 20 20"
            fill="#059669"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
              clipRule="evenodd"
            />
          </svg>
        </Button>
      
      {/* {filterOpen &&(
        <ModalBox Modal_Body={ModalBody} Modal_Header={ModalHeader} modal_Close_Class="mt-2.5 border-2 pl-2 pr-2 pt-1 pb-1 rounded-lg mr-6" Modal_Close_Func={handleCloseFilter} cardClass="min-w-md  bg-white shadow rounded-lg overflow-hidden h-full !rouded-none !w-96 opacity-none overflow-y-auto" ModalTopClass="!items-right !justify-end "/>
      )}
      {saveProject &&(
        <ModalBox Modal_Body={AnotherProject} Modal_Footer={SaveProjectFooter} Modal_Header={ProjectHeader} modal_Header_Text="text-2xl font-[500] mb-0" modal_Close_Class="mt-3 border-2 pl-2 pr-2 pt-1 pb-1 rounded-lg mr-5" Modal_Close_Func={handleCloseProject} cardClass="min-w-md  bg-white shadow rounded-lg overflow-hidden h-auto grid gap-[30px] p-[30px] !rouded-xl no-max-width !w-[719px] opacity-none overflow-y-auto"/>
      )}

      {isProjectCreation &&(
        <ModalBox Modal_Body={<ProjectCreation onClose={handleCloseNewProject}/>}  modal_Close_Class="mt-3 border-2 pl-2 pr-2 pt-1 pb-1 rounded-lg mr-5" Modal_Close_Func={handleCloseNewProject} cardClass="min-w-md  bg-white shadow rounded-lg overflow-hidden h-auto grid gap-[30px] p-[30px] !rouded-xl no-max-width !w-[719px] opacity-none overflow-y-auto"/>
      )} */}
      
      {isOpen && (
        <div
          className="absolute z-10 w-8/12 mt-2 top-9 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
          ref={dropdownRef}
        >
          <div className="p-1 space-y-0.5">
      <a className="flex items-center gap-x-3.5 border-b-2 border-gray-100 py-2 px-3  text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
        Uncontacted
      </a>
      <a className="flex items-center gap-x-3.5 py-2 px-3 border-b-2 border-gray-100  text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
        Contacted
      </a>
      <a className="flex items-center gap-x-3.5 py-2 px-3  text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
        Replied
      </a>
      
    </div>
        </div>
      )}
      {isOpenMessage && (
        <div
          className="absolute left-4 z-10 w-10/12 top-11 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
          ref={dropdownRef}
        >
          <div className="p-1 space-y-0.5">
      <a className="flex items-center gap-x-3.5 py-2 px-3   text-xs text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
        Hide Candidate
      </a>
      <a className="flex items-center gap-x-3.5 py-2 px-3   text-xs text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
      Add Note
      </a>
      {/* <a className="flex items-center gap-x-3.5 py-2 px-3   text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" onClick={handleSaveToProject} href="#">
      Save To Another Project
      </a> */}
      <a className="flex items-center gap-x-3.5 py-2 px-3   text-xs text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
      Share for Review
      </a>
      <a className="flex items-center gap-x-3.5 py-2 px-3   text-xs text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
      Save To Another Project
      </a>
      <a className="flex items-center gap-x-3.5 py-2 px-3   text-xs text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
      Save to PDF
      </a>
      <a className="flex items-center gap-x-3.5 py-2 px-3  text-xs text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline" href="#">
      Find More People Like This
      </a>
      
    </div>
        </div>
      )}
    
    
                    
                    <Button type="button" className="!bg-gray-100  ml-3 h-9 items-center justify-between px-2 py-2 rounded-md border border-gray-300 shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={toggleDropdownMessage}>
                <img src="/image/message.png" className='w-5' />
            </Button>
            <button id="dropdownMenuIconButton" data-dropdown-toggle="dropdownDots" className="p-1 h-5 mb-1 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none dark:text-white focus:ring-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-600" type="button">
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
            <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>
            </svg>
            </button>
            </div>
            </div>






                </div>
                <div className="grid gap-[32px]">
                <div className="mt-4 flex gap-[32px]">
                    <div className="w-[80px]">
                  <p className="ml-2 text-black mb-0 text-[12px] font-[500]">Experience</p></div>
                  <div>
                    <p className="text-xs opacity-[50%] mb-0 font-[500]">4+ years of experience in UX design</p>
                    <p className="text-black text-xs flex font-[400] mb-0"><span className="text-green-700 font-[700] mr-1">Senior UX Designer</span> at NovaByte Solutions <li className="ml-2 mb-0 text-gray-700">Current</li></p>
                    <p className="text-black text-xs font-[400] flex mb-0">UX Designer CodeSphere Technologies <li className=" mb-0 text-gray-700 ml-2">2021-2022</li></p>
                    <p className="text-black text-xs font-[400] flex mb-0">UX Designer BlueShift Dynamics <li className=" mb-0 text-gray-700 ml-2">2019-2021</li></p>
                  </div>
                </div>
                <div className="flex gap-[32px]">
                    <div className="w-[80px]">
                  <p className="ml-2 text-black mb-0 text-xs font-[500]">Education</p></div>
                  <div>
                    
                    <p className="text-black flex text-xs mb-0">Bachelor of Design, Srishti Manipal Institute<li className=" mb-0 text-gray-700 ml-2">2014-2017</li></p>
                    <p className="text-black flex text-xs mb-0">Masters Strategic Design Management, NID<li className=" mb-0 text-gray-700 ml-2">2017-2019</li></p>
                  </div>
                </div>
                <div className="flex gap-[32px]">
                <div className="w-[80px]">
                  <p className="ml-2 text-xs mb-0 font-[500] text-black">Skills Match</p></div>
                  <div>
                    
                    <p className="flex text-xs text-green-700 mb-0 font-medium">User Research <li className="text-xs ml-2">User-Centered Design Thinking</li><li className="ml-2">Problem-solving</li></p>
                  </div>
                </div>
                <div className="flex mb-4 gap-[32px]">
                    <div className="w-[80px]">
                  <p className="ml-2 text-black mb-0 text-xs font-[500]">Activity</p></div>
                  <div className="w-[381px] justify-between">
                    
                    <p className="text-black flex text-xs mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, Masters StrLorem ipsum dolor sit amet, consectetur adipiscing elit, ategic Design Management, NID</p>
                    
                  </div>
                </div>
                </div>
                </>}
                />
                
                {isResumeDetailsEmpty ? (
            processingMessage == "Data Updation Processing" ? (
              <div className="bg-white m-4 rounded-lg text-center py-32">
                <p>Please wait while we process your request. Resume matching is in progress... Loading.. </p>
                <ClipLoader color="#3498db" size={50} />
              </div>
              ):(
              <div className="bg-white  m-4 rounded-lg text-center py-32">{processingMessage}</div>)
          ) : (
            Object.entries(filteredResumes).map(([project, index]) => (
          <Card CardFooterClass=" !bg-[#059669] !rounded-l-none w-1/5 ml-auto flex justify-end" key={index} CardClass="min-w-md mx-auto pl-2 bg-white shadow rounded-lg overflow-hidden mt-4 mb-4 !rounded-3xl shadow-none border w-12/12"
           body={
            <>
            <div className="flex">
            <div className="w-full">
              <div className="flex">
                <div className="flex">
            <p className="text-[24px] font-medium mb-0">{filteredResumes[project] && filteredResumes[project]['candidate'] && filteredResumes[project]['candidate']['name']?filteredResumes[project]['candidate']['name']:"Name Not Provided"}</p>
            {fitment.forEach((fitment, index) => {
              if (fitment.resume_id == filteredResumes[project]['doc_id']) {
                console.log("fitment inside id", fitment.resume_id);
                score = fitment.score;
              }
            })}
            <div className="pl-2 relative ml-6   h-9 bg-white mt-1 w-20 pb-1  rounded-md ">
                <div className="relative size-6 mt-1">
                <svg className="size-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">

                  <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-gray-200 dark:text-neutral-700" strokeWidth="4"></circle>

                  {Math.floor(score*100) >= 75 ? (
                  <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-green-700 dark:text-blue-500" strokeWidth="4" stroke-dasharray="100" stroke-dashoffset={100- Math.floor(score*100)} stroke-linecap="round"></circle>
                ):(
                  <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-red-600 dark:text-blue-500" strokeWidth="4" stroke-dasharray="100" stroke-dashoffset={100- Math.floor(score*100)} stroke-linecap="round"></circle>
                )}
                </svg>
        
                </div>
          
           
                <div className="absolute rounded-lg inset-2 ml-8 mt-2 mr-2 flex items-center  justify-center  text-gray-700 dark:text-white">
                  
                  <div className="h-14">
                    <p className="mb-0 text-black font-medium mt-1 ml-3">{Math.floor(score*100)}%</p>
                    
                  </div>
                </div>
                <p className="text-xs mb-0 absolute inset-y-4 ml-8">Match</p>
                
                </div>
                </div>

    <div className="ml-auto">
      <div className="flex relative items-center" ref={dropdownRef}>
	{filteredResumes[project] &&
  filteredResumes[project]['comment_count'] !== undefined &&
  filteredResumes[project]['comment_count'] !== null && (
    filteredResumes[project]['comment_count'] === 0 ? (
      <p onClick={() => setResumeMessage(filteredResumes[project]["doc_id"],decryptedMetadataAll['cid'])} className="cursot-pointer bg-red-500 text-white px-2 rounded-full mb-0 mt-1">No Comments</p>
    ) : (
      <p onClick={() => setResumeMessage(filteredResumes[project]["doc_id"],decryptedMetadataAll['cid'])} className="cursor-pointer bg-yellow-500 px-2 rounded-full mb-0 mt-1">
       Comments: {filteredResumes[project]['comment_count']}
      </p>
    )
  )}
    <div className="pl-8">
    {filteredResumes[project]["pipeline_type"]?
    <p className="text-lg mt-1 mr-4 text-green-700 mb-0 w-[190px] text-right">{filteredResumes[project]["pipeline_type"]}</p>:(
    <Button
      type="button"
      className="text-nowrap inline-flex w-[190px] mr-4 justify-between rounded-md bg-white pl-3 border-green-500  text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      id="menu-button"
      aria-expanded={isOpen}
      aria-haspopup="true"
      onClick={()=>toggleDropdownResumePipeline(index)}
    >
      <p className="mt-2 mb-0 text-[16px] font-medium text-green-600">Save to Pipeline</p>
      <div className="border-l-[1px] border-green-600 h-10 w-8  flex items-center justify-center">
      <svg
        className=" size-6 text-gray-400"
        viewBox="0 0 20 20"
        fill="green"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
          clipRule="evenodd"
        />
      </svg>
    </div>
    </Button>)}
  
  

  
  {isResumeOpen===index && (
    <div
      className="absolute left-34  z-10 !w-[190px] mt-2  origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex="-1"
      ref={dropdownRefOne}
    >
      <div class="p-1 space-y-0.5">
  <a class="flex items-center gap-x-3.5 border-b-2 border-gray-100 py-2 px-3 hover:cursor-pointer  text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline"  onClick={()=>handlePipelineStatus("contact",index,filteredResumes[project]['candidate']['name'],filteredResumes[project]['candidate']['email'],jobTitle,Math.floor(score*100))}>
    Contact
  </a>
  <a class="flex items-center gap-x-3.5 py-2 px-3 border-b-2 border-gray-100 hover:cursor-pointer text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline"  onClick={()=>handlePipelineStatus("shortlist",index,filteredResumes[project]['candidate']['name'],filteredResumes[project]['candidate']['email'],jobTitle,Math.floor(score*100))}>
  Shortlist
  </a>
  
  
</div>
    </div>
    )}
    </div>
    <Button className="bg-white h-6 mt-2 border-none" onClick={()=>toggleDropdownResumeOption(index)}>
        <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={20}
                height={20}
                className="ml-auto "
                fill="black"
                aria-hidden="true"
                >
                <circle cx="5" cy="12" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="19" cy="12" r="2" />
                </svg>
                </Button>
{isResumeOption===index && (
    <div
      className="absolute right-0 top-10  z-50 !w-[190px] mt-2  origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex="-1"
      ref={dropdownRefTwo}
    >
      <div class="p-1 space-y-0.5">
  <a class="flex items-center gap-x-3.5  py-2 px-3 hover:cursor-pointer  text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline"
  target="_blank"
    href={
      project && filteredResumes[project]["doc_id"] && decryptedMetadataAll && decryptedMetadataAll['cid']
        ? `${process.env.REACT_APP_SERVER_BASEURL}/resumes/${decryptedMetadataAll['cid']}/resume/${filteredResumes[project]["doc_id"]}.pdf`
        : "#"
    }
    >
    View Resume
  </a>
  <a class="flex items-center gap-x-3.5  py-2 px-3 hover:cursor-pointer  text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700 no-underline"
     href="#" 
     onClick={(e) => {
        e.preventDefault();
        setResumeMessage(filteredResumes[project]["doc_id"],decryptedMetadataAll['cid']);
      }}
        >
        Comment
      </a>
      
      
        </div>
        </div>
        )}
        </div>

        </div>
                </div>
                <div className="flex mt-4 w-[50%]">
              <div className="w-full flex items-center">
                <p className="text-[14px] mt-2 pr-4 w-3/6 relative group cursor-pointer">
                  <div className="flex justify-between items-center">
                    <span>Must Have</span>
                    <span>{Object.values(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.must_have || {}).filter(value => value === 1).length}/{Object.keys(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.must_have || {}).length}</span>
                  </div>
                  <div className="relative w-full h-2 bg-gray-200 rounded mt-1">
                    <div className="absolute top-0 left-0 h-full bg-[#059669] rounded" style={{ width: `${(Object.values(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.must_have || {}).filter(value => value === 1).length / Object.keys(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.must_have || {}).length) * 100}%` }}></div>
                  </div>
                  <div className="absolute hidden group-hover:block bg-white border border-gray-300 rounded p-2 mt-1 w-80 max-h-40 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                    {Object.entries(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.must_have || {}).map(([key, value]) => (
                      <div key={key} className="flex border-b-[1px] gap-2 border-gray-200 items-center py-2">
			    <div className="w-1/12">
                        {value === 1 ? (
                          <svg className="w-full text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                        ) : (
                          <svg className="w-full text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        )}
			</div><div className="w-11/12">
                        <span>{key}</span></div>
                      </div>
                    ))}
                  </div>
                </p>
                <p className="text-[14px] mt-2 w-3/6 pl-4 relative group cursor-pointer">
                  <div className="flex justify-between items-center">
                    <span>Nice To Have</span>
                    <span>{Object.values(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.nice_to_have || {}).filter(value => value === 1).length}/{Object.keys(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.nice_to_have || {}).length}</span>
                  </div>
                  <div className="relative w-full h-2 bg-gray-200 rounded mt-1">
                    <div className="absolute top-0 left-0 h-full bg-[#059669] rounded" style={{ width: `${(Object.values(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.nice_to_have || {}).filter(value => value === 1).length / Object.keys(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.nice_to_have || {}).length) * 100}%` }}></div>
                  </div>
                  <div className="absolute hidden group-hover:block bg-white border border-gray-300 rounded p-2 mt-1 w-80 max-h-40 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                    {Object.entries(fitment.find(fitmentItem => fitmentItem.resume_id === filteredResumes[project]['doc_id'])?.nice_to_have || {}).map(([key, value]) => (
                      <div key={key} className="flex border-b-[1px] gap-2 border-gray-200 items-center py-2">
			    <div className="w-1/12">
                        {value === 1 ? (
                          <svg className="w-full text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                        ) : (
                          <svg className="w-full text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        )}
			</div><div className="w-11/12">
                        <span>{key}</span></div>
                      </div>
                    ))}
                  </div>
                </p>
              </div>
            </div>
            <p className="text-[14px] mt-4">{filteredResumes[project] && filteredResumes[project]['candidate'] && filteredResumes[project]['candidate']['objective']&&filteredResumes[project]['candidate']['objective']}</p>
            <p className="text-[16px] font-semibold mb-0">Contact Details</p>
            
            <p className="flex text-[16px]"><div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" className="mt-2 mr-2" viewBox="0 0 15 11" fill="none">
<path d="M14 2V9C14 9.39782 13.842 9.77936 13.5607 10.0607C13.2794 10.342 12.8978 10.5 12.5 10.5H2.5C2.10218 10.5 1.72064 10.342 1.43934 10.0607C1.15804 9.77936 1 9.39782 1 9V2M14 2C14 1.60218 13.842 1.22064 13.5607 0.93934C13.2794 0.658035 12.8978 0.5 12.5 0.5H2.5C2.10218 0.5 1.72064 0.658035 1.43934 0.93934C1.15804 1.22064 1 1.60218 1 2M14 2V2.162C14 2.4181 13.9345 2.66994 13.8096 2.89353C13.6848 3.11712 13.5047 3.30502 13.2867 3.43933L8.28667 6.516C8.05014 6.66169 7.7778 6.73883 7.5 6.73883C7.2222 6.73883 6.94986 6.66169 6.71333 6.516L1.71333 3.44C1.49528 3.30569 1.31525 3.11779 1.19038 2.8942C1.06551 2.6706 0.999972 2.41876 1 2.16267V2" stroke="#059669" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              
              <p className="mt-[1px]">{filteredResumes[project] && filteredResumes[project]['candidate'] && filteredResumes[project]['candidate']['email']?filteredResumes[project]['candidate']['email']:"Email Not Provided"}</p></div>
<div className="flex ml-4">
<svg xmlns="http://www.w3.org/2000/svg" className="mt-1.5 mr-2" width="15" height="15" viewBox="0 0 15 15" fill="none">
<path d="M1 4C1 9.52267 5.47733 14 11 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V11.5853C14 11.2413 13.766 10.9413 13.432 10.858L10.4833 10.1207C10.19 10.0473 9.882 10.1573 9.70133 10.3987L9.05467 11.2607C8.86667 11.5113 8.542 11.622 8.248 11.514C7.15659 11.1128 6.16544 10.4791 5.34319 9.65681C4.52094 8.83457 3.88725 7.84341 3.486 6.752C3.378 6.458 3.48867 6.13333 3.73933 5.94533L4.60133 5.29867C4.84333 5.118 4.95267 4.80933 4.87933 4.51667L4.142 1.568C4.10143 1.4058 4.00781 1.2618 3.87604 1.15889C3.74426 1.05598 3.58187 1.00006 3.41467 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V4Z" stroke="#059669" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  {filteredResumes[project] &&
  filteredResumes[project]['candidate'] &&
  filteredResumes[project]['candidate']['phone_number'] ? (
    <a href={`tel:${filteredResumes[project]['candidate']['phone_number']}`} className="text-black no-underline">
      {filteredResumes[project]['candidate']['phone_number']}
    </a>
  ) : (
    <p className="text-gray-500">Phone No Not Provided</p>
  )}
  </div></p></div>
      </div>
        </>
           }
           footer={
        <>
         {fitment.map((fitmentItem) => {
              if (fitmentItem.resume_id == index.doc_id) {
                return (
                  <p key={fitmentItem.resume_id} className="mb-0 text-white">
                    {fitmentItem.resume_source == "user" ? "From Resumebox" : "From Naukri"}
                  </p>
                );
              }
              return null;
            })}
            {/* <p key={index.doc_id} className="mb-0 text-white">
              {index.resume_source == "user" ? "From Resumebox" : "From Naukri"}
            </p> */}
           <p className="mb-0 text-white hidden">From Resumebox</p>
            </>
           }
          />
          )))}
            </div>

        </div>
    </>
    );
}
export default RecommendedMatches;
